var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1706 8.36775H17.4993V8.33317H9.99935V11.6665H14.7089C14.0218 13.6069 12.1756 14.9998 9.99935 14.9998C7.2381 14.9998 4.99935 12.7611 4.99935 9.99984C4.99935 7.23859 7.2381 4.99984 9.99935 4.99984C11.2739 4.99984 12.4335 5.48067 13.3164 6.26609L15.6735 3.909C14.1852 2.52192 12.1943 1.6665 9.99935 1.6665C5.39726 1.6665 1.66602 5.39775 1.66602 9.99984C1.66602 14.6019 5.39726 18.3332 9.99935 18.3332C14.6014 18.3332 18.3327 14.6019 18.3327 9.99984C18.3327 9.44109 18.2752 8.89567 18.1706 8.36775Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62695 6.12109L5.36487 8.129C6.1057 6.29484 7.89987 4.99984 9.99945 4.99984C11.274 4.99984 12.4336 5.48067 13.3165 6.26609L15.6736 3.909C14.1853 2.52192 12.1945 1.6665 9.99945 1.6665C6.79862 1.6665 4.02279 3.47359 2.62695 6.12109Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 18.3331C12.1533 18.3331 14.1091 17.5094 15.5879 16.1698L13.0087 13.9873C12.1439 14.645 11.0872 15.0007 10.0008 14.9998C7.83328 14.9998 5.99286 13.6177 5.29953 11.689L2.58203 13.7827C3.9612 16.4815 6.76203 18.3331 10.0008 18.3331Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1712 8.36784H17.5V8.33325H10V11.6666H14.7096C14.3809 12.5901 13.7889 13.3971 13.0067 13.9878L13.0079 13.987L15.5871 16.1695C15.4046 16.3353 18.3333 14.1666 18.3333 9.99992C18.3333 9.44117 18.2758 8.89575 18.1712 8.36784Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d850520b70554691bb71102a3d75638b.svg";
export { ForwardRef as ReactComponent };